import classnames from 'classnames'
import { useSelector } from 'react-redux'

import Button from 'shared/components/Button'
import EditBookingPriceBreakdown from 'shared/components/EditBookingPriceBreakdown'
import { PriceToPay } from 'shared/components/EditBookingPriceBreakdown/PriceToPay'
import featureToggles from 'shared/featureToggles'
import { locationDetailsSelector, isGooglePaySelectedSelector } from 'booking/selectors'
import { GOOGLE_PAY_METHOD } from 'shared/transactions'
import GooglePayButton from 'credit-cards/google-pay/components/GooglePayButton'
import { googlePayIsReadyToPaySelector, googlePayPendingSelector } from 'credit-cards/google-pay/selectors'

import styles from '../styles.module.scss'

const FooterSection = ({
    rate,
    total,
    loading,
    disabled,
    setPriceBreakdownModalOpen,
    rateCurrencySymbol,
    editedReservationNewTotalPrice,
    amendmentFee,
    oldPrice,
    newPrice,
    showPriceDifference,
    onBuyNowClick,
}) => {
    const isGooglePaySelected = useSelector(isGooglePaySelectedSelector)

    return (
        <div className={styles.footerSection}>
            {!featureToggles.hidePriceBreakdown && (
                <Button
                    onClick={() => setPriceBreakdownModalOpen(true)}
                    className="mb-2"
                    type="button"
                    size="small"
                    btnStyle="link">
                    <T>price.breakdown</T>
                </Button>
            )}
            {showPriceDifference ? (
                <EditBookingPriceBreakdown
                    rate={rate}
                    oldPrice={oldPrice}
                    newPrice={newPrice}
                    editedReservationNewTotalPrice={editedReservationNewTotalPrice}
                    amendmentFee={amendmentFee}
                />
            ) : (
                <PriceToPay rate={rate} label={<T>subscripition.purchase.pay.label.total</T>} total={total} />
            )}
            <div className={classnames('d-sm-flex justify-content-between align-items-center', styles.buyBtnContainer)}>
                {isGooglePaySelected ? (
                    <GooglePayButton
                        disabled={disabled}
                        isLoading={loading}
                        totalPrice={total}
                        onClick={onBuyNowClick}
                        fallbackLabel={<T>booking.btn.buy.now</T>}
                    />
                ) : (
                    <Button
                        id="booking-btn-buy-now"
                        isLoading={loading}
                        btnStyle="primary"
                        type="submit"
                        disabled={disabled}>
                        <T>booking.btn.buy.now</T>
                    </Button>
                )}
            </div>
        </div>
    )
}

export default FooterSection
